export enum MapStatus {
  WORKING = 2,
  REST = 1,
  NOT_START = 0,
}

export enum SiteDirectorEnteringStatus {
  LEAVE,
  COME_IN,
  REPLACEMENT_STAFF,
}
